<template>
  <div class="progress-wrap">
    <div v-show="currentIndex>0"
      @click="onPreviou"
      class="btn-pre">上一题</div>
    <div class="progress-box">
      <div :style="{'width':`${proccess}%`}"
        class="progress-do"></div>
    </div>
    <div>{{proccess || 0}}%</div>
  </div>
</template>

<script>
export default {
  props: {
    // 当前题目索引
    currentIndex: {
      type: Number
    },
    // 最大做题索引
    maxIndex: {
      type: Number
    },
    // 题目数量
    total: {
      type: Number
    }
  },
  computed: {
    proccess () {
      const val = this.currentIndex / (this.total - 1) * 100
      return val.toFixed(0)
    }
  },
  methods: {
    // 上一题
    onPreviou () {
      this.$emit('on-previou')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variable.scss";

.progress-wrap {
  color: $turquoise;
  display: flex;
  align-items: center;
  font-size: 12px;
  .btn-pre {
    &:active {
      opacity: 0.5;
    }
  }
  .progress-box {
    background: rgba(61, 211, 203, 0.1);
    border-radius: 5px;
    height: 8px;
    flex: 1;
    margin: 0 10px;
    .progress-do {
      background-color: $turquoise;
      border-radius: 5px;
      height: 100%;
      width: 0%;
    }
  }
}
</style>
